<script setup lang="ts">
  import { UiButton } from '@logistiek-zonder-papier/lzp-library'
  import { useRouter } from 'vue-router'

  const router = useRouter()
</script>
<template>
  <div class="container">
    <h1>Page not found!</h1>
    <p>Deze pagina kon niet gevonden worden.</p>
    <UiButton
      label="Terug naar de startpagina."
      variant="link"
      @click="router.push(router.currentRoute.value.fullPath.startsWith('/home') ? '/home' : '/')"
    />
    <UiButton label="Terug naar de vorige pagina." variant="link" @click="router.back()" />
  </div>
</template>

<style lang="css" scoped>
  .container {
    max-width: 100%;
    height: 100vh;
    background-color: var(--colours-grey-1);
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: var(--spacing-xl) 0 0 0;
    margin: 0;
  }
</style>
